import React, { useState, useCallback } from 'react';
import { sendEmailVerification } from 'firebase/auth';
import { auth } from '../firebase';
import { EnvelopeIcon } from '@heroicons/react/24/outline';

export default function EmailVerificationBanner({ userProfile }) {
  const [sent, setSent] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  const handleResend = useCallback(async () => {
    if (cooldown > 0 || !auth.currentUser) return;
    try {
      await sendEmailVerification(auth.currentUser);
      setSent(true);
      setCooldown(60);
      const interval = setInterval(() => {
        setCooldown((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } catch (err) {
      console.error('Failed to send verification email:', err);
    }
  }, [cooldown]);

  // Only show for email/password users who haven't verified
  if (!userProfile || userProfile.authProvider !== 'email' || userProfile.emailVerified) {
    return null;
  }

  return (
    <div className="gch-info-bar mb-4">
      <span className="inline-flex items-center gap-2">
        <EnvelopeIcon className="w-4 h-4 text-[var(--admin-accent)] shrink-0" />
        <span className="text-xs font-medium gch-text-secondary">
          {sent
            ? 'Verification email sent. Check your inbox and spam folder.'
            : <><span className="text-white font-semibold">Email not verified.</span> Verify your email to secure your account.</>}
        </span>
      </span>
      <button
        type="button"
        onClick={handleResend}
        disabled={cooldown > 0}
        className="gch-info-bar-action disabled:opacity-50"
      >
        {cooldown > 0 ? `Resend (${cooldown}s)` : 'Resend verification'}
      </button>
    </div>
  );
}
